export default "__VITE_ASSET__YqePDcYC__"